module.exports = __webpack_public_path__ + "static/media/the-right-information-at-the-right-time-02@3x.f6968238.png";